import DistrictAdminApi from './DistrictAdminApi';
export default DistrictAdminApi;
